import { render } from "./CmsRefusedProductsEditor.vue?vue&type=template&id=310ae897&scoped=true"
import script from "./CmsRefusedProductsEditor.vue?vue&type=script&lang=js"
export * from "./CmsRefusedProductsEditor.vue?vue&type=script&lang=js"

import "./CmsRefusedProductsEditor.vue?vue&type=style&index=0&id=310ae897&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310ae897"]])

export default __exports__